import { useState } from 'react';
import HtmlContent from '../components/HtmlContent';
import { usePageTitle } from '../hooks/usePageTitle';
import { useUpdateDay, useUpdatesList } from '../hooks/useUpdates';

export default function UpdatesPage() {
  usePageTitle('Updates');
  const { data: dates, isLoading: listLoading } = useUpdatesList();
  const [selected, setSelected] = useState<string | null>(null);

  const selectedDate = selected ?? dates?.[0]?.date ?? null;
  const { data: day, isLoading: dayLoading } = useUpdateDay(selectedDate);

  return (
    <div data-testid="updates-page">
      <h1 className="page-title">Updates</h1>
      <div style={{ display: 'flex', gap: '1.5rem', alignItems: 'flex-start' }}>
        <aside
          data-testid="updates-date-list"
          style={{
            width: 200,
            flexShrink: 0,
            background: 'var(--bg-alt)',
            border: '1px solid var(--border)',
            borderRadius: 'var(--radius)',
            padding: '0.5rem',
          }}
        >
          {listLoading ? <div className="empty-state">Loading...</div> : null}
          {dates?.length === 0 ? <div className="empty-state">No update entries yet.</div> : null}
          <ul style={{ listStyle: 'none', margin: 0, padding: 0 }}>
            {dates?.map((d) => (
              <li key={d.date}>
                <button
                  type="button"
                  data-testid={`updates-date-${d.date}`}
                  onClick={() => setSelected(d.date)}
                  aria-current={selectedDate === d.date ? 'true' : 'false'}
                  style={{
                    display: 'block',
                    width: '100%',
                    textAlign: 'left',
                    background: selectedDate === d.date ? 'var(--accent-bg)' : 'transparent',
                    color: selectedDate === d.date ? 'var(--accent)' : 'var(--text)',
                    border: 0,
                    padding: '0.4rem 0.6rem',
                    margin: '1px 0',
                    borderRadius: 'var(--radius-sm)',
                    fontWeight: selectedDate === d.date ? 500 : 400,
                    cursor: 'pointer',
                  }}
                >
                  <div>{d.date}</div>
                  <div className="subtle" style={{ fontSize: 11 }}>{d.count} entries</div>
                </button>
              </li>
            ))}
          </ul>
        </aside>
        <section data-testid="updates-day-content" style={{ flex: 1, minWidth: 0 }}>
          {dayLoading ? <div className="muted">Loading...</div> : null}
          {day ? <HtmlContent html={day.html} testId="updates-day-html" /> : null}
        </section>
      </div>
    </div>
  );
}
